import * as React from 'react';

function ClosureIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg {...props} width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.1143 2.78137C6.6144 2.28128 7.29267 2.00033 7.99992 2.00033C8.70716 2.00033 9.38544 2.28128 9.88554 2.78137C10.3856 3.28147 10.6666 3.95975 10.6666 4.66699V6.66699H5.33325V4.66699C5.33325 3.95975 5.6142 3.28147 6.1143 2.78137ZM3.99992 6.66699V4.66699C3.99992 3.60613 4.42135 2.58871 5.17149 1.83857C5.92164 1.08842 6.93905 0.666992 7.99992 0.666992C9.06078 0.666992 10.0782 1.08842 10.8283 1.83857C11.5785 2.58871 11.9999 3.60613 11.9999 4.66699V6.66699H12.6666C13.7712 6.66699 14.6666 7.56242 14.6666 8.66699V13.3337C14.6666 14.4382 13.7712 15.3337 12.6666 15.3337H3.33325C2.22868 15.3337 1.33325 14.4382 1.33325 13.3337V8.66699C1.33325 7.56242 2.22868 6.66699 3.33325 6.66699H3.99992ZM11.3333 8.00033H4.66659H3.33325C2.96506 8.00033 2.66659 8.2988 2.66659 8.66699V13.3337C2.66659 13.7018 2.96506 14.0003 3.33325 14.0003H12.6666C13.0348 14.0003 13.3333 13.7018 13.3333 13.3337V8.66699C13.3333 8.2988 13.0348 8.00033 12.6666 8.00033H11.3333Z"
        fill="#CFD4DA"
      />
    </svg>
  );
}

const MemoClosureIcon = React.memo(ClosureIcon);
export default MemoClosureIcon;
